
 

 

 

 
class ChangePasswordUpdateRequest 
{
    
        OldPassword: string;
    
        NewPassword: string;
    
        ConfirmPassword: string;
    
}
 
export default ChangePasswordUpdateRequest;
 




